/** Filter options and badge styling shared across the dashboard tables. */

export const SERVICE_OPTIONS = [
  { value: "all", label: "All services" },
  { value: "afs", label: "Financial Statements" },
  { value: "assurance", label: "Audit / Review" },
  { value: "bookkeeping", label: "Bookkeeping" },
  { value: "financial_management", label: "Outsourced finance" },
];

export const STATUS_OPTIONS = [
  { value: "all", label: "All sessions" },
  { value: "completed", label: "Completed the gate" },
  { value: "dropped", label: "Dropped off" },
  { value: "reached_gate", label: "Reached gate, didn't finish" },
  { value: "fallback", label: "Routed to fallback" },
];

export const LEAD_STATUS_OPTIONS = [
  { value: "all", label: "All leads" },
  { value: "open", label: "Still open" },
  { value: "gone_quiet", label: "Gone quiet (7+ days)" },
  { value: "action_due", label: "Next action due" },
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "awaiting_decision", label: "Awaiting decision" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "false_lead", label: "False lead" },
  { value: "finance", label: "Scoping enquiries" },
  { value: "closed", label: "Closed enquiries" },
];

/** New / Contacted / Closed, for the outsourced finance scoping enquiries. */
export const FINANCE_STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "closed", label: "Closed" },
];

export const ESCALATION_STATE_OPTIONS = [
  { value: "open", label: "Waiting on us" },
  { value: "overdue", label: "Overdue only" },
  { value: "handled", label: "Already handled" },
  { value: "all", label: "Everyone" },
];

export const ROUTE_BADGES = {
  rule_escalation: {
    label: "Stop-and-check",
    className:
      "border-[color:var(--tt-warn-border)] bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)]",
  },
  self_serve: {
    label: "Asked us to call",
    className:
      "border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)]",
  },
};

export const STAGE_STYLES = {
  new: "border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)]",
  contacted:
    "border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)]",
  awaiting_decision:
    "border-[color:var(--tt-warn-border)] bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)]",
  won: "border-emerald-200 bg-emerald-50 text-emerald-800",
  lost: "border-border bg-muted text-muted-foreground",
  closed: "border-border bg-muted text-muted-foreground",
  false_lead: "border-dashed border-muted-foreground/40 bg-muted text-muted-foreground",
};

export const OUTCOME_STYLES = {
  quote:
    "bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)] border-[color:var(--tt-teal-line)]",
  fallback:
    "bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)] border-[color:var(--tt-warn-border)]",
  in_progress: "bg-muted text-muted-foreground border-border",
};

export const OUTCOME_LABELS = {
  quote: "Quoted",
  fallback: "Fallback",
  in_progress: "In progress",
};
